import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { patchRoom, roomDeleteDevice } from '@app/actions/rooms/rooms'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import EditRoom from '@app/components/Rooms/EditRoom/EditRoom'
import {
  withNotifications, withAccessDenied, withProgressAndErrorMessage, withRouter,
} from '@app/hocs'

let enhance = EditRoom

const mapStateToProps = (state) => {
  const { isMobile, isTablet } = state.mobileDetector
  const {
    rooms: {
      zWaveDevices,
      twrDevices,
    },
  } = store.getState()
  return {
    isMobile,
    isTablet,
    zWaveDevices,
    twrDevices,
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessToken: state.secrets.accessToken && state.secrets.accessToken.token,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  patchRoom,
  roomDeleteDevice,
}, dispatch)

enhance = withRouter(enhance)
enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const EditRoomEnhanced = enhance

export default EditRoomEnhanced
